<template>
  <span class="value-show">
    <div v-if="item.company">{{item.company}}</div>
    <div v-if="item.city">{{item.city}}</div>
  </span>
</template>
<script>
export default {
  props: ['item', 'column', 'model']
}
</script>



// WEBPACK FOOTER //
// CollectionValueCompany.vue?5f00d658